import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';

import { renderRichText } from 'gatsby-source-contentful/rich-text';
import standardRichTextStyling from './rich-text-options/standardRichTextStyling';
import standardHtmlStyling from './rich-text-options/standardHtmlStyling';

const TextWrapper = styled.div``;

const StyledTextBlocks = ({ textBlock, className, options, richTextStyle }) => {
	let textBlockContent = null;

	if (textBlock?.childMarkdownRemark?.html) {
		textBlockContent = standardHtmlStyling(
			textBlock.childMarkdownRemark.html,
			options
		);
	} else if (textBlock?.raw) {
		textBlockContent = renderRichText(
			textBlock,
			richTextStyle ? richTextStyle(options) : standardRichTextStyling(options)
		);
	} else {
		textBlockContent = textBlock;
	}
	return <TextWrapper className={className}>{textBlockContent}</TextWrapper>;
};

export default StyledTextBlocks;
